import React from "react";
import { Icon } from "@dc/react-components";
import PropTypes from "prop-types";

function Filter({
  buttonClassName,
  textContainerClassName,
  text,
  iconSrc,
  iconSize,
  isExtraThin,
  iconClassName,
  onClickHandler
}) {
  return (
    <li className="filter-tiles__option">
      <button onClick={() => onClickHandler(text)} className={buttonClassName}>
        {iconSrc && <Icon Source={iconSrc} size={iconSize} isExtraThin={isExtraThin} className={iconClassName} />}
        <span className={textContainerClassName}>{text}</span>
      </button>
    </li>
  );
}

function Filters(data) {
  return (
    <ul className="filter-tiles__container">
      {data.filters.map(function (filter, index) {
        return <Filter key={index} {...filter} />;
      })}
    </ul>
  );
}

Filter.propTypes = {
  buttonClassName: PropTypes.string,
  textContainerClassName: PropTypes.string,
  text: PropTypes.string,
  iconSrc: PropTypes.object,
  iconSize: PropTypes.string,
  isExtraThin: PropTypes.string,
  iconClassName: PropTypes.string,
  onClickHandler: PropTypes.func
};

export default Filters;
